import { useTranslation } from 'react-i18next'

import { GooglePlayIcon } from '@/components/GooglePlayIcon/GooglePlayIcon'
import { appLinks } from '@/config/links'

import { FAQItem } from '@/pages/Support/FAQItem'
import { readSupportFaqs } from '@/pages/Support/readSupportFaqs'

export function SupportPage() {
  const { t } = useTranslation()
  const faqs = readSupportFaqs(t)
  const contactEmail = t('common.contactEmail')
  const mailto = `mailto:${contactEmail}`

  return (
    <div className="min-h-screen" style={{ background: '#F0F4FF' }}>
      <div
        className="pt-16"
        style={{ background: 'linear-gradient(135deg, #0D1B3E 0%, #1A2E5A 50%, #0A1628 100%)' }}
      >
        <div className="mx-auto max-w-4xl px-4 py-16 text-center sm:px-6 lg:px-8">
          <div
            className="mb-5 inline-flex items-center gap-2 rounded-full px-4 py-2"
            style={{ background: 'rgba(0, 200, 150, 0.12)', border: '1px solid rgba(0, 200, 150, 0.2)' }}
          >
            <div className="h-2 w-2 rounded-full" style={{ background: '#00C896', boxShadow: '0 0 6px #00C896' }} />
            <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '13px', fontWeight: 600, color: '#00C896' }}>
              {t('support.heroBadge')}
            </span>
          </div>
          <h1
            style={{
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(28px, 4vw, 48px)',
              color: 'white',
              letterSpacing: '-0.04em',
              marginBottom: '16px',
            }}
          >
            {t('support.heroTitle')}
          </h1>
          <p
            style={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: '16px',
              color: 'rgba(255,255,255,0.55)',
              maxWidth: '480px',
              margin: '0 auto',
              lineHeight: 1.7,
            }}
          >
            {t('support.heroSubtitle')}
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-4 py-16 sm:px-6 lg:px-8">
        {/*<div className="mb-16 flex justify-center">*/}
        {/*  <a*/}
        {/*    href={mailto}*/}
        {/*    className="minego-card flex w-full max-w-md flex-col gap-5 p-8 transition-all duration-200 sm:p-10"*/}
        {/*    style={{ textDecoration: 'none', border: '1.5px solid rgba(26, 86, 255, 0.18)' }}*/}
        {/*  >*/}
        {/*    <div className="flex h-14 w-14 items-center justify-center rounded-2xl" style={{ background: 'rgba(26, 86, 255, 0.07)' }}>*/}
        {/*      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden>*/}
        {/*        <path*/}
        {/*          d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"*/}
        {/*          stroke="#1A56FF"*/}
        {/*          strokeWidth="1.8"*/}
        {/*          strokeLinejoin="round"*/}
        {/*        />*/}
        {/*        <path d="M22 6l-10 7L2 6" stroke="#1A56FF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />*/}
        {/*      </svg>*/}
        {/*    </div>*/}
        {/*    <div className="text-left">*/}
        {/*      <h2*/}
        {/*        style={{*/}
        {/*          fontFamily: 'Outfit, sans-serif',*/}
        {/*          fontWeight: 800,*/}
        {/*          fontSize: '22px',*/}
        {/*          color: '#0D1B3E',*/}
        {/*          letterSpacing: '-0.02em',*/}
        {/*          marginBottom: '8px',*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        {t('support.emailOnlyTitle')}*/}
        {/*      </h2>*/}
        {/*      <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '14px', color: '#6B7A99', lineHeight: 1.65, marginBottom: '12px' }}>*/}
        {/*        {t('support.emailOnlyDesc')}*/}
        {/*      </p>*/}
        {/*      <p style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: '15px', fontWeight: 600, color: '#1A56FF', wordBreak: 'break-all' }}>*/}
        {/*        {contactEmail}*/}
        {/*      </p>*/}
        {/*    </div>*/}
        {/*    <span*/}
        {/*      className="inline-flex items-center justify-center gap-2 rounded-2xl py-3.5 text-center text-sm font-semibold"*/}
        {/*      style={{*/}
        {/*        background: '#0D1B3E',*/}
        {/*        color: 'white',*/}
        {/*        fontFamily: 'DM Sans, sans-serif',*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      {t('support.emailOnlyCta')}*/}
        {/*      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>*/}
        {/*        <path d="M5 12h14M13 6l6 6-6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />*/}
        {/*      </svg>*/}
        {/*    </span>*/}
        {/*    <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '13px', color: '#9BA8BE', lineHeight: 1.6, textAlign: 'left', margin: 0 }}>*/}
        {/*      {t('support.emailOnlyNote')}*/}
        {/*    </p>*/}
        {/*  </a>*/}
        {/*</div>*/}

        <div className="mb-16">
          <div className="mb-10 text-center">
            <h2
              style={{
                fontFamily: 'Outfit, sans-serif',
                fontWeight: 800,
                fontSize: 'clamp(22px, 3vw, 32px)',
                color: '#0D1B3E',
                letterSpacing: '-0.03em',
                marginBottom: '8px',
              }}
            >
              {t('support.faqTitle')}
            </h2>
            <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '15px', color: '#6B7A99' }}>{t('support.faqSubtitle')}</p>
          </div>
          <div>
            {faqs.map((faq, i) => (
              <FAQItem key={`${i}-${faq.q}`} q={faq.q} a={faq.a} index={i} />
            ))}
          </div>
        </div>

        <div
          className="relative overflow-hidden rounded-3xl p-8 text-center sm:p-12"
          style={{ background: 'linear-gradient(135deg, #0D1B3E 0%, #1A2E5A 100%)' }}
        >
          <div
            className="absolute top-0 right-0 h-64 w-64 rounded-full"
            style={{ background: 'radial-gradient(circle, rgba(26,86,255,0.15) 0%, transparent 70%)', filter: 'blur(40px)' }}
          />
          <div className="relative">
            <h3
              style={{
                fontFamily: 'Outfit, sans-serif',
                fontWeight: 800,
                fontSize: 'clamp(22px, 3vw, 32px)',
                color: 'white',
                letterSpacing: '-0.03em',
                marginBottom: '12px',
              }}
            >
              {t('support.ctaTitle')}
            </h3>
            <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '15px', color: 'rgba(255,255,255,0.55)', marginBottom: '28px' }}>
              {t('support.ctaSubtitle')}
            </p>
            <div className="flex flex-col justify-center gap-4 sm:flex-row">
              <a
                href={appLinks.googlePlay}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 rounded-2xl px-6 py-4 transition-all duration-200"
                style={{
                  background: 'white',
                  color: '#0D1B3E',
                  textDecoration: 'none',
                  boxShadow: '0 4px 20px rgba(255,255,255,0.15)',
                }}
              >
                <GooglePlayIcon size={22} />
                <div className="text-left">
                  <div style={{ fontSize: '9px', opacity: 0.5, lineHeight: 1, fontFamily: 'DM Sans' }}>{t('common.getItOn')}</div>
                  <div style={{ fontSize: '16px', fontWeight: 700, fontFamily: 'DM Sans', lineHeight: 1.2 }}>{t('common.googlePlay')}</div>
                </div>
              </a>
              <a
                href={mailto}
                className="inline-flex items-center justify-center gap-2 rounded-2xl px-6 py-4 transition-all duration-200"
                style={{
                  background: 'rgba(255,255,255,0.08)',
                  border: '1.5px solid rgba(255,255,255,0.15)',
                  color: 'white',
                  textDecoration: 'none',
                  fontFamily: 'DM Sans, sans-serif',
                  fontWeight: 600,
                  fontSize: '15px',
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    stroke="white"
                    strokeWidth="1.8"
                    strokeLinejoin="round"
                  />
                  <path d="M22 6l-10 7L2 6" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {t('support.emailSupport')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
